import { useState, useEffect } from 'react';
import { NavLink, useNavigate, useLocation } from 'react-router-dom';
import { Home, LayoutGrid, MessageSquare, Menu as MenuIcon } from 'lucide-react';
import useShiftsStore from '../store/useShiftsStore';
import useAuthStore from '../store/useAuthStore';
import { useToast } from './ToastProvider';
import chatWebsocket from '../services/chatWebsocket';
import useChatStore from '../store/useChatStore';
import './BottomNavigation.css';

function BottomNavigation() {
  const navigate = useNavigate();
  const location = useLocation();
  const { activeShifts } = useShiftsStore();
  const { user, isShiftRequired, can } = useAuthStore();
  const { showToast } = useToast();
  const shiftRequired = isShiftRequired();
  const hasShift = !shiftRequired || activeShifts.length > 0;
  const feedActive = location.pathname.startsWith('/feed');
  // Если у гостя в шаблоне выключена «Лента» — прячем кнопку, чтобы он не упирался в пустой экран
  const canViewFeed = can('feed', 'view');
  const chatActive = location.pathname.startsWith('/chat');
  const unreadTotal = useChatStore((s) => s.unreadTotal);
  const [badgeCount, setBadgeCount] = useState(0);

  // Ensure WebSocket is connected (idempotent; полная сессия — в Layout).
  // Передаём актуальный токен, чтобы сбросить authFailed (если предыдущая
  // аутентификация WS была отклонена сервером).
  useEffect(() => {
    if (!user) return;
    const token = localStorage.getItem('token');
    if (token) chatWebsocket.setToken(token);
    chatWebsocket.connect();
  }, [user]);

  // Счётчик из глобального store; в открытом чате скрываем бейдж
  useEffect(() => {
    if (!user) return;
    setBadgeCount(chatActive ? 0 : unreadTotal);
  }, [chatActive, unreadTotal, user]);

  return (
    <nav className="bottom-nav">
      <NavLink
        to="/"
        className={({ isActive }) =>
          `bottom-nav-item ${isActive ? 'active' : ''}`
        }
      >
        {({ isActive }) => (
          <>
            <Home size={22} />
            <span className="bottom-nav-label">Главная</span>
            {isActive && <span className="bottom-nav-indicator" />}
          </>
        )}
      </NavLink>

      {canViewFeed && (
        <button
          type="button"
          className={`bottom-nav-item ${feedActive ? 'active' : ''} ${!hasShift ? 'opacity-40' : ''}`}
          onClick={() => {
            if (!hasShift) {
              showToast('Сначала откройте смену на главной странице', { type: 'warning' });
              return;
            }
            navigate('/feed');
          }}
        >
          <LayoutGrid size={22} />
          <span className="bottom-nav-label">Лента</span>
          {feedActive && <span className="bottom-nav-indicator" />}
        </button>
      )}

      <NavLink
        to="/chat"
        className={({ isActive }) =>
          `bottom-nav-item ${isActive ? 'active' : ''}`
        }
      >
        {({ isActive }) => (
          <>
            <div className="bottom-nav-icon-wrapper">
              <MessageSquare size={22} />
              {badgeCount > 0 && (
                <span className="bottom-nav-badge">{badgeCount}</span>
              )}
            </div>
            <span className="bottom-nav-label">Чат</span>
            {isActive && <span className="bottom-nav-indicator" />}
          </>
        )}
      </NavLink>

      <NavLink
        to="/menu"
        className={({ isActive }) =>
          `bottom-nav-item ${isActive ? 'active' : ''}`
        }
      >
        {({ isActive }) => (
          <>
            <MenuIcon size={22} />
            <span className="bottom-nav-label">Меню</span>
            {isActive && <span className="bottom-nav-indicator" />}
          </>
        )}
      </NavLink>
    </nav>
  );
}

export default BottomNavigation;
